import { FieldError, FieldErrorsImpl, Merge } from 'react-hook-form'

export const castError = (
  error: string | FieldError | Merge<FieldError, FieldErrorsImpl> | undefined
) => {
  if (typeof error === 'string') return error
  if (error?.message) return String(error.message)
  return undefined
}
